/*
 |--------------------------------------------------------------------------
 | Runtime polyfills
 |--------------------------------------------------------------------------
 |
 | Must stay the FIRST import in resources/js/app.js. Webpack evaluates ESM
 | imports in source order and hoists all of them above the CommonJS
 | require('./bootstrap') call, so anything placed after the vue or
 | @inertiajs/vue3 imports would run too late.
 |
 | Only add entries here for built-ins a dependency calls unguarded. Mix's
 | babel-loader excludes node_modules (laravel-mix/src/components/JavaScript.js),
 | so everything under there ships exactly as published, and @babel/preset-env
 | would not help regardless - it rewrites syntax, not built-ins, and there is
 | no core-js in this project to draw polyfills from.
 */

/*
 * Object.hasOwn is ES2022 (Chrome 93+, Firefox 92+, Safari 15.4+). es-toolkit calls it unguarded
 * from assignValue(), which sits on the code path @inertiajs/vue3's useForm() runs while mounting,
 * so on an older engine the entire Vue mount died and the visitor got a blank page instead of a
 * login form (Sentry HQAM-CUSTOMER-PORTAL-2, thrown from <Login>).
 *
 * defineProperty rather than a plain assignment: `Object.hasOwn = ...` would leave an enumerable own
 * property on Object. Object(target) reproduces the spec's ToObject coercion, so primitives behave
 * like they do under the native method.
 */
if (typeof Object.hasOwn !== 'function') {
    Object.defineProperty(Object, 'hasOwn', {
        value: (target, property) => Object.prototype.hasOwnProperty.call(Object(target), property),
        configurable: true,
        writable: true,
    });
}
